export const AssetType ={
    CAMERA : 'TrafficCamera',
    TRAFFIC_SIGNAL : 'TrafficSignal',
    SPEED_DETECTOR : 'speed_detector',
    MESSAGE_BOARD : 'message_board'
}
export const MAP_BOX_API_KEY = 'pk.eyJ1IjoiaW5kcmF2YXJhIiwiYSI6ImNtMzF1djRqODB5cjUybnBzbDV5dTNxZGYifQ.e8fny9QnRmanWc-00ywSig';